<template>
  <div class="invitations-table">
    <SetColorAndLogoReminder
      v-if="!currentCompany.accountant_branding.color || !currentCompany.accountant_branding.logo"
    />

    <FilterBar
      cookieName="AccountantPendingInvitationsFilterOptionsVue"
      :mainFilters="['SearchFilter']"
      filterBarType="accountant-pending-invitations"
      @change="filtersChanged"
    />

    <div class="content--inner">
      <overlay-scrollbars class="invitations-table-scrollbar">
        <b-table
          :items="tableItems"
          :fields="fields"
          striped
          hover
          :class="['table gk-table gk-table--responsive gk-table--striped gk-table--hover']"
          :busy="loading"
          show-empty
          table-busy
          ref="invite-table"
        >
          <template #empty="">
            <span class="empty-table-text" v-translate>You have no pending invites.</span>
          </template>
          <template #table-busy="">
            <b-skeleton-table
              :rows="10"
              :columns="4"
              :table-props="{ bordered: false, striped: true }"
              :hide-header="true"
            />
          </template>
          <template #cell(created)="data">
            {{ data.item.created | formatDate }}
          </template>
          <template #cell(invite_to_name)="data">
            <div>{{ data.item.invite_to_name }}</div>
            <div class="email-text">{{ data.item.invite_to }}</div>
          </template>
          <template #cell(actions)="data">
            <b-dropdown class="icon-toggle ui-dashboard-menu-dropdown" variant="link" right no-caret>
              <template #button-content>
                <font-awesome-icon icon="fa-solid fa-ellipsis-vertical" />
              </template>
              <b-dropdown-item @click="resendInvitation(data.item)">
                <font-awesome-icon icon="fa-regular fa-paper-plane" />
                <span>{{ $gettext('Resend invitation') }}</span>
              </b-dropdown-item>
              <b-dropdown-divider />
              <DropdownItemDelete :item="data.item" :item-type="'accountant_invitation'" @item-deleted="onInvitationDeleted" />
            </b-dropdown>
          </template>
          <template #row-details="row">
            <span class="message-text">
              {{ row.item.message }}
            </span>
          </template>
        </b-table>
      </overlay-scrollbars>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import FilterBar from '@/components/list_filters/FilterBar'

import AccountantsService from '@/store/services/accountants.service'
import GekkoButton from '@/components/GekkoButton'
import SetColorAndLogoReminder from '@/components/accountants/SetColorAndLogoReminder.vue'
import DropdownItemDelete from '@/components/ui/DropdownItemDelete'
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"

export default {
  name: 'InvitationsList',
  components: {
    GekkoButton,
    SetColorAndLogoReminder,
    FilterBar,
    DropdownItemDelete,
    LoadingSpinner
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'created', tdClass: 'date-cell' },
        { key: 'invite_to_name', label: this.$gettext('Invitee') },
        { key: 'actions', tdClass: 'col-actions', thClass: 'text-center' },
      ],
      loading: true,
      currentFilters: null,
    }
  },
  computed: {
    ...mapGetters({
      currentCompany: 'accountants/getCurrentAccountantCompany',
    }),
    tableItems() {
      return (this.items || []).map(it => ({ ...it, _showDetails: true }))
    }
  },
  created() {
    this.setupData()
  },
  methods: {
    ...mapActions({ 
      resendInvitation: "accountants/resendInvitation",
    }),
    setupData() {
      this.getPendingInvites(this.currentFilters)
    },
    getPendingInvites(filters) {
      this.loading = true
      filters = {
        ...filters,
        status: 'pending'
      }
      AccountantsService.getPendingInvites(filters).then((response) => {
        this.items = response.data
      }).finally(() => { this.loading = false })
    },
    filtersChanged(filters) {
      this.currentFilters = filters
      this.getPendingInvites(filters)
    },
    onInvitationDeleted () {
      this.getPendingInvites()
    }
  },
}
</script>

<style lang="scss" scoped>
.invitations-table {
  .os-host.invitations-table-scrollbar {
    min-height: 360px;
  }
  &.table-on-modal {
    .os-host.invitations-table-scrollbar {
      height: 300px !important;
      max-height: 300px;
      .os-content { padding: 0 !important; }
    }
  }
}
.message-text {
  font-style: italic;
  color: $colorTextSemi;
}
.email-text {
  font-size: 12px;
  color: $colorTextSemi;
}
</style>

<style>
.date-cell {
  min-width: 120px;
  width: 120px;
  vertical-align: middle !important;
}
</style>